import styled from 'styled-components'

export const SignatureContainer = styled.div`
    position: absolute;
    bottom: 60px;
    right: 60px;
    width: 120px;
    z-index: 5;
    @media screen and (max-width: ${({theme})=>theme.breakpoints.tabletSmall}){
        display: none;
    }
`